import React, { useEffect, useState } from "react";
import { getProgramListCSRPlacement, getMandateListCSRPlacement } from "lib/axiosUtils";
import Select from "react-select";

const FinalPlacementCSRWidget = ({ value, onChange, id, formContext }) => {
  const isCSR = formContext?.projectType === "csr" ||
    (typeof formContext?.viewStepData?.csr_other_placement === 'object' && formContext?.viewStepData?.csr_other_placement !== null);
  const isViewData = formContext?.viewStepData?.csr_other_placement?.csrOtherPlacement ? true : false;
  const formDisable = formContext?.formDisable === true;
  const viewData = formContext?.viewStepData?.csr_other_placement || null;
  const ref = formContext?.csrPlacementRef;
  const projectType = formContext?.projectType || null

  const [otherPlacement, setOtherPlacement] = useState(false);
  const [selectedProject, setSelectedProject] = useState("");
  const [selectedEmployer, setSelectedEmployer] = useState("");
  const [projectList, setProjectList] = useState([]);
  const [employerList, setEmployerList] = useState([]);
  const [allProjectData, setAllProjectData] = useState([]);
  const [placementType, setPlacementType] = useState("Project");
  const [selectedMandate, setSelectedMandate] = useState("");
  const [mandateList, setMandateList] = useState([]);

  //Populate view mode defaults
  useEffect(() => {
    if (isViewData && viewData && allProjectData.length > 0) {
      setOtherPlacement(true);
      setSelectedProject(viewData.programId || "");
      setSelectedEmployer(viewData.employerId || "");
      setPlacementType(viewData?.placementType || "Project");
      setSelectedMandate(viewData.mandateId || "");
    }
  }, [isViewData, viewData, allProjectData]);

  // Save to ref for parent to use on submit
  useEffect(() => {
    if (!isCSR || !ref?.current) return;

    ref.current = {
      csrOtherPlacement: otherPlacement,
      programId: selectedProject,
      employerId: selectedEmployer,
      placementType: placementType,
      mandateId: selectedMandate
    };
  }, [otherPlacement, selectedProject, selectedEmployer, isCSR, ref, placementType, selectedMandate]);

  useEffect(() => {
    if (!isCSR) return;
    const fetchProjects = async () => {
      try {
        const response = await getProgramListCSRPlacement({}, {});
        let all = [];
        if (typeof formContext?.viewStepData?.csr_other_placement === 'object' && formContext?.viewStepData?.csr_other_placement !== null) {
          all = response.data.result;
        } else if (formContext?.programId) {
          all = response.data.result.filter(p => p._id !== formContext.programId);
        }
        else {
          all = response.data.result;
        }
        setAllProjectData(all);
        setProjectList(
          all.map(p => ({
            label: p.program_name,
            value: p._id
          }))
        );
      } catch (err) {
        console.error("Error fetching CSR projects:", err);
      }
    };

    const fetechMandate = async () => {
      try {
        const mandateResponse = await getMandateListCSRPlacement({}, {});
        const allMandate = mandateResponse.data.result;
        setMandateList(
          allMandate.map(m =>
          ({
            label: m.organisation_name,
            value: m._id
          })));

      } catch (err) {
        console.error("Error fetching mandates:", err);
      }
    }

    fetchProjects();
    fetechMandate();
  }, [isCSR, formContext?.programId, formContext?.viewStepData?.csr_other_placement, formContext?.mandateId]);

  // Fetch employer list for selected project
  useEffect(() => {
    if (!selectedProject) {
      setEmployerList([]);
      return;
    }

    const project = allProjectData.find(p => p._id === selectedProject);
    if (project) {
      setEmployerList(
        Array.isArray(project.employerItem)
          ? project.employerItem.map(e => ({ label: e.unit_name, value: e._id }))
          : []
      );
    }
  }, [selectedProject, allProjectData]);

  // Sync to hiddenFields
  useEffect(() => {
    if (!isCSR) return;

    const employerLabel = employerList.find(e => e.value === selectedEmployer)?.label || "";
    const projectLabel = projectList.find(p => p.value === selectedProject)?.label || "";
    const mandateLabel = mandateList.find(m => m.value === selectedMandate)?.label || "";

    formContext?.setHiddenFields?.(prev => ({
      ...prev,
      showProjectFields: otherPlacement,
      selectedProjectLabel: projectLabel,
      selectedEmployerLabel: employerLabel,
      selectedEmployerId: selectedEmployer,
      candidateAcceptance: value,
      selectedMandate,
      selectedMandateLabel: mandateLabel
    }));
  }, [otherPlacement, selectedProject, selectedEmployer, employerList, projectList, isCSR, formContext, value, placementType, selectedMandate, mandateList]);

  return (
    <div>
      <div className="mb-3">
        <label htmlFor="tjp-placement">TJP Project Placement</label>
        <Select
          inputId="tjp-placement"
          isDisabled={(projectType === "csr" && isViewData) ? false : isViewData ? true : formDisable}
          value={otherPlacement ? { value: "yes", label: "Yes" } : { value: "no", label: "No" }}
          onChange={opt => {
            const isYes = opt?.value === "yes";
            setOtherPlacement(isYes);
          }}
          options={[
            { value: "no", label: "No" },
            { value: "yes", label: "Yes" }
          ]}
          placeholder="Select"
        />
      </div>

      {otherPlacement && (
        <>
          {/* NEW RADIO SECTION */}
          <div className="mb-3">
            <label className="mb-2 d-block"> Select Project/Mandate </label>
            <div className="d-flex gap-4">
              <label>
                <input type="radio"
                  value="Project"
                  checked={placementType === "Project"}
                  disabled={formDisable}
                  onChange={() => setPlacementType("Project")}
                />
                {" "}Project
              </label>
              <label className="ml-4">
                <input type="radio"
                  value="Mandate"
                  checked={placementType === "Mandate"}
                  disabled={formDisable}
                  onChange={() => setPlacementType("Mandate")}
                />
                {" "}Mandate
              </label>
            </div>
          </div>
          {/* PROJECT FLOW */}
          {placementType === "Project" && (
            <>
              <div className="mb-3">
                <label>Select Project</label>
                <Select
                  isDisabled={(projectType === "csr" && isViewData) ? false : isViewData ? true : formDisable}
                  value={projectList.find(p => p.value === selectedProject) || null}
                  onChange={opt => setSelectedProject(opt?.value || "")}
                  options={projectList}
                  placeholder="Select"
                />
              </div>
              <div className="mb-3">
                <label>Select Employer Unit</label>
                <Select
                  isDisabled={(projectType === "csr" && isViewData) ? false : isViewData ? true : formDisable}
                  value={employerList.find(e => e.value === selectedEmployer) || null}
                  onChange={opt => setSelectedEmployer(opt?.value || "")}
                  options={employerList}
                  placeholder="Select"
                />
              </div>
            </>
          )}

          {/* MANDATE FLOW */}
          {placementType === "Mandate" && (
            <div className="mb-3">
              <label>Select Mandate</label>
              <Select
                isDisabled={formDisable}
                value={
                  mandateList.find(
                    m => m.value === selectedMandate
                  ) || null
                }
                onChange={opt => setSelectedMandate(opt?.value || "")}
                options={mandateList}
                placeholder="Select Mandate"
              />
            </div>
          )}
        </>
      )}

      <div className="mt-4">
        <label htmlFor={id}>Final Placement Candidate Acceptance (Y/N)</label>
        <Select
          inputId={id}
          isDisabled={(projectType === "csr" && isViewData) ? false : isViewData ? true : formDisable}
          value={
            value === true ? { value: "yes", label: "Yes" }
              : value === false ? { value: "no", label: "No" }
                : null
          }
          onChange={opt => onChange(opt?.value === "yes")}
          options={[
            { value: "yes", label: "Yes" },
            { value: "no", label: "No" }
          ]}
          placeholder="Select"
        />
      </div>
    </div>
  );
};

export default FinalPlacementCSRWidget;